import React, { useContext } from 'react'
import { Upselling } from '../../components/upselling/upselling'
import { track } from '../../ClevertapWrapper'
import { useNavigate } from 'react-router-dom'
import routes from '../../router/routes'
import { clevertapEvents } from '../../labels'
import { FeatureContext } from '../../context/useFeatureFlagContext'
import { useUpselling } from '../../hooks/useUpselling'

export function Analysis() {
    const upselling = useUpselling()

    const navigate = useNavigate()
    const { features } = useContext(FeatureContext)

    const handlerNavigate = (route: string, _track?: string) => {
        if (_track) {
            track(_track)
        }

        navigate(route)
    }

    const goToDashboard = () => {
        upselling.updateUpselling('reports', true)
        handlerNavigate(`/${routes.urlDashboard}`, clevertapEvents.drawerReport)
    }

    return (
        <Upselling
            active={features.reports}
            feature={{
                image: require('../../assets/images/upselling/analysis.png'),
                title: 'Ya puedes acceder al Análisis de tu Negocio',
                btn: {
                    title: 'Ir a tu dashboard',
                    action: () => goToDashboard(),
                },
            }}
            pending={{
                headtitle: 'Análisis de tu negocio',
                title: 'Accede a análisis y datos importantes de tu negocio',
                text: 'Reportería avanzada, con información de ventas, información de locales y comparativos con la industria y competidores, todo eso explicado de forma simple y con actualización automática',
                list: [
                    'Información historica de venta',
                    'Comparativos con datos de la industria',
                    'Información sobre tus consumidores',
                    'Tus tickets promedios',
                    'Estatisticas  de evaluaciones y comentarios',
                ],
                // btn1: {
                //     title: 'Contratar',
                //     action: () => {
                //         navigate('/subscription')
                //     },
                // },
                btn2: {
                    title: 'Hablar con Ventas',
                    action: () => {
                        window.open(
                            'https://amipass.typeform.com/to/BcTVDWHf?typeform-source=amipass.atlassian.net',
                            '_blank'
                        )
                    },
                },
                image: require('../../assets/images/upselling/analysis.png'),
                contract: 'contratando este complemento',
            }}
        />
    )
}
